module.exports = __webpack_public_path__ + "img/secondday1-2.f5dcad26.jpg";